export const marketplaceCurrentStatuses = Object.freeze({
  ACTIVE: 'Active',
  REINVITE: 'Reinvite',
  PENDING: 'Pending',
  INVITE: 'Invite',
});
